import Moment from 'moment-timezone';
import { i18n } from '@/plugins/i18n';
import {
  getRecurrenceBreakdown,
  getLabelsAndDatasetsFromRecurrence,
  recurrenceChartOptions,
} from '@/utils/vhub-utils';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/**
 * Score based on the number of times team's indicators overrun their objectives
 * A pareto chart will also be diplayed for more details and concatenation accross multiple teams
 */
export default new VitalityCriterion({
  titleTr: 'VH_I_RECURRENCE',
  key: 'indicatorExceedingRecurrence',
  weight: 2.5,
  defaultChartIndex: 1,

  score: ({ themes }, { start, end }) => {
    let nValues = 0;
    let nExcess = 0;
    const allValues = themes.reduce((tValues, theme) => {
      const indicValues = theme.indicators.reduce((iValues, indic) => {
        let values = [];
        if (indic.copyPublic === null && indic.inputValues) {
          const objIsMax = indic.objectiveIsMax === 1;
          const iDate = Moment(start);
          while (!iDate.isAfter(end)) {
            const key = iDate.format('YYYY-MM-DD');
            const v = indic.inputValues[key];
            if (v && v.value !== null) {
              nValues++;
              if (
                (objIsMax && v.value > indic.objectives[v.reported]) ||
                (!objIsMax && v.value < indic.objectives[v.reported])
              ) {
                nExcess++;
                values.push({ libId: indic.libraryId, libName: indic.libName });
              }
            }
            iDate.add(1, 'd');
          }
        }
        return [...iValues, ...values];
      }, []);
      return [...tValues, ...indicValues];
    }, []);

    const breakdown = getRecurrenceBreakdown(allValues, 'libId', 'libName');
    const score = nValues === 0 ? 0 : (nValues - nExcess) * 100 / nValues;

    return {
      score: score,
      data: {
        noTopsFlops: nValues === 0,
        noCategoryHint: nValues === 0,
        value: breakdown.maxOccurrences,
        text: breakdown.maxText,
        itemsPerRecurrenceId: breakdown.itemsPerRecurrenceId,
        nExcess,
        nValues,
      },
    };
  },

  text({ value, text, nExcess, nValues }) {
    if (nValues === 0) {
      return i18n.t('message.VH_I_NO_VALUES');
    }
    if (value > 1) {
      // All values details text
      const details = i18n.t('message.VH_I_EXCEEDING_TEXT', { nb: nExcess, nValues });
      // Max occurrences text
      text = text.length > 28 ? `${text.substring(0, 25)}...` : text;
      return i18n.t('message.VH_I_RECURRENCE_TEXT', { val: value, text, details });
    }
    return i18n.t('message.VH_I_RECURRENCE_NONE_TEXT');
  },

  chartData(teamGroups) {
    // Display a stacked bar chart. The item with the most NOK occurrences first and decreasing
    return getLabelsAndDatasetsFromRecurrence(teamGroups, this.scoresKey);
  },

  chartOptions() {
    return recurrenceChartOptions;
  },

  chartNames() {
    return i18n.t('message.PARETO');
  },
});
